export const INITIAL_ROUTE = "/";
export const EXPERIENCE = "/job-experience";
export const PROJECTS = "/projects";
export const ARTICLES = "/articles";
